{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "सभी विकल्प देखें",
  "Spoiler_Reveal_Tooltip": "देखने की लिए क्लिक करें",
  "VerticalEmbed_Event_Error_Subtitle": "यह इवेंट डिलीट कर दिया गया है, कृपया इसके स्थान पर दूसरा इवेंट चुनें।",
  "Viewer_Toolbar_Twitter_Tooltip": "इसे ट्वीट करें",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "आइटम को छोटा किया गया है",
  "Spoiler_Reveal_Video_CTA": "वीडियो उजागर करें",
  "VerticalEmbed_Pricing_Plan": "योजना केवल",
  "Image_Expand_Button_AriaLabel": "छवि का विस्तार करें",
  "VerticalEmbed_From_Price": "प्रेषक",
  "Poll_Viewer_ShowAllResults_CTA": "सभी परिणाम देखें",
  "Spoiler_Reveal_Image_Placeholder": "इस छवि में एक स्पॉइलर है",
  "VerticalEmbed_Ribbon": "बिक्री",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "स्लाइडर की तलाश करें",
  "VerticalEmbed_Error_Subtitle": "इस आइटम को हटा दिया गया है, इसे किसी दूसरे आइटम से बदलें।",
  "Poll_Viewer_Multiselect_Footer": "आप एक से अधिक उत्तर के लिए मतदान कर सकते हैं।",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "और ऑडियो नियंत्रण दिखाएं",
  "VerticalEmbed_Booking_Fetch_Error_Title": "सेवा लोड नहीं हो सकी।",
  "Fullscreen_Close_Button_AriaLabel": "बंद करें",
  "VerticalEmbed_Event_Fetch_Error_Title": "इवेंट लोड नहीं हो सका।",
  "UploadFile_Viewer_Loader": "{{fileType}} लोड हो रही है",
  "Polls_Plugin_User_Avatar_Alt": "उपयोगकर्ता अवतार",
  "Preview_ReadMore_Label": "अधिक पढ़ें",
  "Spoiler_Insert_Tooltip": "स्पॉइलर",
  "VerticalEmbed_Product_Fetch_Error_Title": "उत्पाद लोड नहीं हो सका।",
  "Fullscreen_Shrink_Button_AriaLabel": "छोटा करें",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "वॉल्यूम",
  "Spoiler_Reveal_Gallery_Placeholder": "इस गैलरी में एक स्पॉइलर है",
  "Fullscreen_Expand_Button_AriaLabel": "एक्सपैंड़ करें",
  "VerticalEmbed_Bookings_Button": "अभी बुक करें",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "अनम्यूट करें",
  "Spoiler_Reveal_Gallery_CTA": "गैलरी उजागर करें",
  "Poll_Viewer_ShowLess_CTA": "कम दिखाएं",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "म्यूट करें",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} बेनाम",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "फोलो करें",
  "VerticalEmbed_Products_Button": "अभी खरीदें",
  "Poll_Viewer_Toast_Error_ServerDown": "सर्वर से कनेक्ट नहीं किया जा सका। बाद में फिर से प्रयास करें।",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} लोगों ने इस उत्तर के लिए वोट किया",
  "Poll_Viewer_VoteCount": "{{number}} वोट",
  "VerticalEmbed_Events_Button": "अभी पंजीकरण करें",
  "Spoiler_Reveal_Image_CTA": "छवि उजागर करें",
  "Poll_Viewer_Toast_Error_Connection": "इंटरनेट नहीं है। अपना कनेक्शन जांचें।",
  "Poll_Viewer_Visibility_Owner_Footer": "केवल आप परिणाम देख सकते हैं।",
  "VerticalEmbed_Booking_Error_Title": "सेवा हटाई गई।",
  "VerticalEmbed_Product_Error_Title": "उत्पाद हटा दिया गया",
  "VerticalEmbed_Fetch_Error_Subtitle": "आइटम की जानकारी लोड नहीं हो पा रही है।",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} लोगों ने इस उत्तर के लिए वोट किया",
  "VerticalEmbed_Event_Error_Title": "इवेंट हटा दिया गया",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "आइटम का विस्तार किया गया है",
  "Audio_Plugin_Cover_Alt": "ऑडियो कवर",
  "Spoiler_Reveal_Video_Placeholder": "इस वीडियो में एक स्पॉइलर है",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "अस्थायी तकनीकी समस्या थी। अपना कनेक्शन जांचें या दोबारा प्रयास करें।",
  "VerticalEmbed_Fetch_Error_Title": "आइटम लोड करने में विफल।",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "इस उत्पाद को हटा दिया गया है, इसे किसी अन्य उत्पाद से बदलें।",
  "VerticalEmbed_Booking_Error_Subtitle": "यह सेवा हटा दी गई है, इसे किसी अन्य सेवा से बदलें।",
  "Preview_SeeFullPost_Label": "पूरी पोस्ट देखें",
  "UploadFile_Viewer_Download": "{{fileType}} डाउनलोड करें",
  "VerticalEmbed_Units_Hour": "{{hours}}h",
  "VerticalEmbed_Units_Minute": "{{minutes}}मिनट",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "अस्थायी तकनीकी समस्या थी। अपना कनेक्शन जांचें या दोबारा प्रयास करें।",
  "VerticalEmbed_Error_Button": "प्रतिस्थापित करे",
  "VerticalEmbed_Error_Title": "आइटम डिलीट किया गया",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "अस्थायी तकनीकी समस्या थी। अपना कनेक्शन जांचें या दोबारा प्रयास करें।",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
